// Description: Policy search functionality.
//
// Refactored to use ES6 syntax and functions.

/**
 * Represents a policy search.
 */
const runPolicySearch = () => {
    let policySearch = null;
    const searchTerm = document.getElementById('fdPolicySearch').value;
    const contentContainer = document.getElementById('rtPolicyContent');
    const resultsContainer = document.getElementById('rtPolicySearchResults');
    policySearch = new PolicySearch(searchTerm, contentContainer, resultsContainer);
    policySearch.search();
};
